<dt-modal-content (closeClick)="close(false)" [size]="size">
  <ng-template #title>{{ modalTitle }}</ng-template>
  <ng-template #content>
    <p data-cy="confirm-prompt" [innerHTML]="prompt"></p>
    @if (listElements) {
      <ul data-cy="confirm-prompt-list">
        @for (item of listElements; track $index) {
          <li>{{ item }}</li>
        }
      </ul>
    }
  </ng-template>
  <ng-template #footer>
    @if (buttonConfirm) {
      <button mat-raised-button (click)="close(true)" [color]="buttonConfirmColor" data-cy="confirm-button">{{ buttonConfirm }}</button>
    }
    @if (buttonDeny) {
      <button mat-raised-button color="accent-less" (click)="close(false)" data-cy="deny-button">{{ buttonDeny }}</button>
    }
  </ng-template>
</dt-modal-content>
